import { useAuthStore } from '@/store/auth.store';
import { revoke } from '@/features/auth';

export function useAuth() {
  const store = useAuthStore();

  return {
    ...store,
    signOut: async () => {
      const { refreshToken } = useAuthStore.getState();
      if (refreshToken) {
        try {
          await revoke(refreshToken);
        } catch {
          // ignore — clear auth regardless
        }
      }
      useAuthStore.getState().clearAuth();
    },
  };
}
